module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-9.9eb0cc48.png";